import React from 'react';

const renderBlock = (block, index) => {
  switch (block.type) {
    case 'heading':
      return <h2 key={index}>{block.text}</h2>;
    case 'subheading':
      return <h3 key={index}>{block.text}</h3>;
    case 'list':
      return (
        <ul key={index}>
          {block.items.map((item, itemIndex) => (
            <li key={itemIndex}>{item}</li>
          ))}
        </ul>
      );
    case 'paragraph':
    default:
      return <p key={index}>{block.text}</p>;
  }
};

const LegalDocument = ({ doc }) => {
  return (
    <div className="legal-document">
      <h1>{doc.title}</h1>
      <p className="legal-document__effective-date">{doc.effectiveDate}</p>
      <p className="legal-document__also-in-app">
        This document is also available inside the Bass Parlour app: Profile → Legal.
      </p>
      {doc.blocks.map(renderBlock)}
    </div>
  );
};

export default LegalDocument;
